// ModalCodigoDeBarras.jsx
import { message, Row, Col, InputNumber, Space, Divider, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, ModalItem } from "../../../../Components/Items";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import etiquetaCodigoBarrasPdf from "../../../../Pdf/etiquetaCodigoBarrasPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalCodigoDeBarras extends Component {
  state = {
    loading: false,
    pdf: null,
    datos: null, // respuesta base del API (codigoBarras, descripcion, unidad)
    // Controles de tamaño
    anchoMm: 60,
    altoMm: 30,
    copias: 1,
    // anti-regen storm
    regenTimer: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  componentWillUnmount() {
    if (this.state.regenTimer) clearTimeout(this.state.regenTimer);
  }

  async consultarTodo() {
    this.setState({ loading: true, pdf: null });
    try {
      const res = await axios.post(
        "insumos/datosCodigBarrasPdf", // <-- tu endpoint (mantengo el de tu ejemplo)
        { insumoId: this.props.insumoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      if (res.data?.success === 2) {
        const { anchoMm, altoMm, copias } = this.state;

        // Guardamos datos base y generamos primera versión
        const datosBase = {
          codigoBarras: res.data.codigoBarras,
          descripcion: res.data.descripcion,
          unidad: res.data.unidad,
        };

        const dd = etiquetaCodigoBarrasPdf({ ...datosBase, anchoMm, altoMm, copias });
        const pdf = pdfMake.createPdf(dd);

        this.setState(
          { loading: false, pdf, datos: datosBase },
          () => pdf.open({}, window.frames["etiquetaCodigoBarrasPdf"])
        );
      } else {
        message.warning("No se encontraron datos para generar la etiqueta.");
        this.setState({ loading: false, pdf: null, datos: null });
      }
    } catch (e) {
      console.error(e);
      message.error("Error al consultar datos para la etiqueta.");
      this.setState({ loading: false, pdf: null, datos: null });
    }
  }

  regenerarPdfDebounced = () => {
    // Debounce cortito para no regenerar en cada tick
    if (this.state.regenTimer) clearTimeout(this.state.regenTimer);
    const regenTimer = setTimeout(this.regenerarPdf, 250);
    this.setState({ regenTimer });
  };

  regenerarPdf = () => {
    const { datos, anchoMm, altoMm, copias } = this.state;
    if (!datos) return;

    try {
      const dd = etiquetaCodigoBarrasPdf({ ...datos, anchoMm, altoMm, copias });
      const pdf = pdfMake.createPdf(dd);
      this.setState({ pdf }, () => pdf.open({}, window.frames["etiquetaCodigoBarrasPdf"]));
    } catch (e) {
      console.error(e);
      message.error("No se pudo regenerar el PDF de la etiqueta.");
    }
  };

  onChangeAncho = (val) => {
    this.setState({ anchoMm: Number(val) || 1 }, this.regenerarPdfDebounced);
  };
  onChangeAlto = (val) => {
    this.setState({ altoMm: Number(val) || 1 }, this.regenerarPdfDebounced);
  };
  onChangeCopias = (val) => {
    const n = Math.max(1, Number(val) || 1);
    this.setState({ copias: n }, this.regenerarPdfDebounced);
  };

  imprimir = () => {
    if (!this.state.pdf) return;
    this.state.pdf.print();
  };

  cerrar = () => {
    this.props.cerrarModalCodigoDeBarras?.();
  };

  render() {
    const { visible } = this.props;
    const { loading, anchoMm, altoMm, copias } = this.state;

    return (
      <ModalItem
        title="Etiqueta de Código de Barras"
        visible={visible}
        spinning={loading}
        onCancel={this.cerrar}
        paddingTop
        // Puedes ajustar el ancho/alto del modal si quieres
      >
        <Space direction="vertical" style={{ width: "100%" }} size="small">
          {/* Controles */}
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={8}>
              <label style={{ display: "block", fontWeight: 600 }}>Ancho (mm)</label>
              <InputNumber
                min={10}
                max={120}
                value={anchoMm}
                onChange={this.onChangeAncho}
                style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} sm={8}>
              <label style={{ display: "block", fontWeight: 600 }}>Alto (mm)</label>
              <InputNumber
                min={10}
                max={120}
                value={altoMm}
                onChange={this.onChangeAlto}
                style={{ width: "100%" }}
              />
            </Col>
            <Col xs={24} sm={8}>
              <label style={{ display: "block", fontWeight: 600 }}>Copias</label>
              <InputNumber
                min={1}
                max={100}
                value={copias}
                onChange={this.onChangeCopias}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>

          <Space>
            <Tooltip title="Genera nuevamente el PDF con los tamaños/copies actuales">
              <ButtonItem onClick={this.regenerarPdf} type="default">Regenerar</ButtonItem>
            </Tooltip>
            <ButtonItem onClick={this.imprimir} type="primary">Imprimir</ButtonItem>
          </Space>

          <Divider style={{ margin: "8px 0" }} />

          {/* Visor PDF */}
          <iframe
            title="etiquetaCodigoBarras"
            id="etiquetaCodigoBarrasPdf"
            name="etiquetaCodigoBarrasPdf"
            style={{ width: "100%", height: "70vh", border: "1px solid #eee", borderRadius: 6 }}
          />
        </Space>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalCodigoDeBarras);
